import React from 'react';

import { useTranslation } from 'react-i18next';

import OwnerPageLayout from '../components/layout/OwnerPageLayout';

import BillingDashboard from '../components/BillingDashboard';



export default function PlatformBillingPage() {

    const { t } = useTranslation('platformBilling');



    return (

        <OwnerPageLayout

            title={t('pageTitle')}

            subtitle={t('pageSubtitle')}

            maxWidth={800}

        >

            <BillingDashboard />

        </OwnerPageLayout>

    );

}


